<template>
  <div>
    <h2>Diary Alert Settings</h2>

    <div class="pt-6">
      <v-alert color="primary" type="info" variant="outlined" density="compact">
        Select classes to display an alert when there are missing entries during approval.
      </v-alert>
    </div>

    <v-container class="pt-10">
      <v-row>
        <h4>Class Diary</h4>
      </v-row>
      <v-row>
        <v-col cols="6" align-self="center">
          <h5>Class</h5>
        </v-col>
        <v-col cols="6" align-self="center">
          <v-select
            v-model="input.classDiaryConfirmation.targetClassIds"
            item-title="className"
            item-value="classId"
            :items="classes"
            chips
            multiple
            variant="outlined"
            density="compact"
            hide-details
            :readonly="isLoading"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="pt-8">
      <v-row>
        <h4>School Diary</h4>
      </v-row>
      <v-row>
        <v-col cols="6" align-self="center">
          <h5>Class</h5>
        </v-col>
        <v-col cols="6" align-self="center">
          <v-select
            v-model="input.schoolDiaryConfirmation.targetClassIds"
            item-title="className"
            item-value="classId"
            :items="classes"
            chips
            multiple
            variant="outlined"
            density="compact"
            hide-details
            :readonly="isLoading"
          ></v-select>
        </v-col>
      </v-row>
    </v-container>

    <div class="d-flex justify-center pt-12">
      <v-btn
        @click="updateDiarySetting"
        :loading="isLoading"
        color="primary"
        variant="flat"
        large
        >{{ $t('common.save') }}
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import LocalDataService from "@/service/LocalDataService";
import { classModule } from "@/store/dataModules/classModule";
import { NurseryClassResponse } from "chaild-api/lib";
import { diarySettingModule } from "@/store/dataModules/diarySettingModule";
import { defineComponent } from "vue";

export default defineComponent({
  name: "DiarySetting",

  async mounted() {
    await this.listClasses();
    await this.listDiarySetting();
  },

  data() {
    return {
      isLoading: false,
      ageItems: [0, 1, 2, 3, 4, 5],
      input: {
        classDiaryConfirmation: {
          targetClassIds: [],
          targetAges: [],
        },
        schoolDiaryConfirmation: {
          targetClassIds: [],
        },
      },
    };
  },

  computed: {
    classes: function (): NurseryClassResponse[] {
      return classModule.classes;
    },
  },

  methods: {
    async listClasses() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule
          .listClass({
            nurseryId,
          })
          .catch();
      }
      this.isLoading = false;
    },
    async listDiarySetting() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await diarySettingModule
          .listDiarySetting({
            nurseryId,
          })
          .catch();
        if (response) {
          this.input.classDiaryConfirmation.targetClassIds =
            response.classDiaryConfirmation.targetClasses.map((c) => {
              return c.classId;
            });
          this.input.classDiaryConfirmation.targetAges =
            response.classDiaryConfirmation.targetAges;
          this.input.schoolDiaryConfirmation.targetClassIds =
            response.schoolDiaryConfirmation.targetClasses.map((c) => {
              return c.classId;
            });
        }
      }
      this.isLoading = false;
    },
    async updateDiarySetting() {
      this.isLoading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await diarySettingModule
          .updateDiarySetting({
            nurseryId,
            ...this.input,
          })
          .catch();
        if (response) {
          alert("Saved successfully");
          await this.listDiarySetting();
        }
      }
      this.isLoading = false;
    },
  },
});
</script>
